<script setup lang="ts">
import type { IBreadcrumb } from '~/interfaces/breadcrumb/IBreadcrumb';

const props = defineProps<{
  breadcrumbsHidden: boolean,
  breadcrumb: IBreadcrumb[]
}>()

const {
  breadcrumbsHidden,
  breadcrumb
} = toRefs(props)

</script>

<template>
  <div>
    <div class="product-page__breadcrumb">
      <div v-if="!breadcrumbsHidden" class="cbreadcrumb cbreadcrumb--light">
        <div
            v-for="(item, index) in breadcrumb"
            :key="index">
          <div>
            <svg v-if="index > 1" class="cicon cicon--12 cicon--bold cbreadcrumb__icon">
              <use xlink:href="#bottom-v2"/>
            </svg>
            <a
                v-if="index > 0"
               :href="item.url"
               class="cbreadcrumb__item"
               data-tclz-selector="breadcrumb"
               :data-tclz-label="index + 1"
               data-tclz-category="breadcrumb">
              <span>{{ item.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="product-page__breadcrumb product-page__breadcrumb--mobile">
      <div v-if="!breadcrumbsHidden" class="cbreadcrumb cbreadcrumb--light">
        <div
            v-for="(item, index) in breadcrumb"
            :key="index">
          <div v-if="index === breadcrumb.length - 2" class="full-width">
            <a
               :href="item.url"
               class="cbreadcrumb__item"
               data-tclz-selector="breadcrumb"
               :data-tclz-label="index + 1"
               data-tclz-category="breadcrumb">
              <svg class="cicon cicon--12 cicon--vt cicon--bold md-ml-h md-mr-h">
                <use xlink:href="#arrow"/>
              </svg>
              <span>{{ item.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
